import React from "react";
import SennesFirst from "./sennes-first";
import Aham from "./aham";
import SennesSecond from "./sennes-second";

const SennesAham = () => {
  return (
    <>
    <SennesFirst/>
    <Aham/>
    <SennesSecond/>
    </>
  );
};

export default SennesAham;
